module.exports = __webpack_public_path__ + "media/images/app/left-arrow-946f89df8f39666f2f74fa991b96f32e.webp";